/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Sessionrevoked2Inputs */

const zh_accountsettings_sessionrevoked2 = /** @type {(inputs: Accountsettings_Sessionrevoked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会话已注销`)
};

const en_accountsettings_sessionrevoked2 = /** @type {(inputs: Accountsettings_Sessionrevoked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session revoked`)
};

const es_accountsettings_sessionrevoked2 = /** @type {(inputs: Accountsettings_Sessionrevoked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesión revocada`)
};

/**
* | output |
* | --- |
* | "Session revoked" |
*
* @param {Accountsettings_Sessionrevoked2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_sessionrevoked2 = /** @type {((inputs?: Accountsettings_Sessionrevoked2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Sessionrevoked2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_sessionrevoked2(inputs)
	if (locale === "en") return en_accountsettings_sessionrevoked2(inputs)
	return es_accountsettings_sessionrevoked2(inputs)
});
export { accountsettings_sessionrevoked2 as "accountSettings_sessionRevoked" }